import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetricsService, TRACKABLE_EVENTS } from '@fb-tool-front/core/services';
import { AuthService } from '@fb-tool-front/core/services/auth.service';
import { CustomDialogService } from '@fb-tool-front/shared/components/dialog/dialog.component';
import { localStorageOnboarding } from '@fb-tool-front/shared/constants/shared.constant';
import { VideoPlayerComponent } from '@fb-tool-front/videos/modals/video-player/video-player.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tuiFadeIn, tuiScaleIn } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@tinkoff/ng-polymorpheus';
import { filter, take } from 'rxjs/operators';
import { StripeStore } from '@fb-tool-front/stripe/store/stripe.store';

@UntilDestroy()
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [tuiScaleIn, tuiFadeIn]
})
export class HomeComponent implements OnInit {
  isPlayingLeft = false;
  isPlayingRight = false;
  isDemoMode$ = this.stripeStore.isDemoMode$;

  constructor(
    private authService: AuthService,
    private stripeStore: StripeStore,
    private router: Router,
    private customDialogService: CustomDialogService,
    private metricsService: MetricsService
  ) {}

  openVideoModal() {
    this.customDialogService
      .open<boolean>(new PolymorpheusComponent(VideoPlayerComponent), {
        closeable: true,
        heading: 'Video player',
        customButtons: true
      })
      .pipe(
        filter(res => !!res),
        untilDestroyed(this)
      )
      .subscribe();
  }

  startOverlaysStepper() {
    this.isDemoMode$.pipe(take(1)).subscribe((isDemoMode: boolean) => {
      if (isDemoMode) {
        this.metricsService.trackEvent(TRACKABLE_EVENTS.letStartDemoClicked());
      } else {
        this.metricsService.trackEvent(TRACKABLE_EVENTS.letStartOverlaysClicked());
      }
    });

    if (
      this.authService.userData$$.value &&
      this.authService.userData$$.value[localStorageOnboarding]
    ) {
      this.router.navigate(['overlays']);
    } else {
      this.router.navigate(['home-overlays']);
    }
  }

  startVideosStepper() {
    this.metricsService.trackEvent(TRACKABLE_EVENTS.letStartVideosClicked());

    this.router.navigate(['videos']);
  }

  ngOnInit(): void {
    this.metricsService.trackEvent(TRACKABLE_EVENTS.visitHome());
  }
}
